<div class="cost-wrapper mt-5">
  <div class="row mx-n2">
    <div class="col-12 px-2">
      <div class="cost mb-3">
        <div class="cost__header bg-primary-l">
          <h4 class="fs fs__md-high">{{ 'nav_total_repair_cost' | translate }}</h4>
        </div>
        <div class="cost__body">
          <div class="cost__type">
            <h2 class="fs fs__md font-weight-bold">SAR {{ totalRepairCost | number:'0.1-2' || '0.00' }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4 px-2">
      <div class="cost mb-3">
        <div class="cost__header">
          <h4 class="fs fs__md">{{ 'nav_exterior' | translate }}</h4>
        </div>
        <div class="cost__body">
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{'condition_modal.labour_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ exteriorLabourCost | number:'0.1-2' || '0.00' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'condition_modal.parts_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ exteriorPartCost | number:'0.1-2' || '0.00' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'nav_repair_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ exteriorCost | number:'0.1-2' || '0.00' }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4 px-2">
      <div class="cost mb-3">
        <div class="cost__header">
          <h4 class="fs fs__md">{{ 'nav_interior' | translate }}</h4>
        </div>
        <div class="cost__body">
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{'condition_modal.labour_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ interiorLabourCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'condition_modal.parts_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ interiorPartCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'nav_repair_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ interiorCost | number:'0.2' }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4 px-2">
      <div class="cost mb-3">
        <div class="cost__header">
          <h4 class="fs fs__md">{{ 'nav_mechanics' | translate }}</h4>
        </div>
        <div class="cost__body">
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{'condition_modal.labour_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ mechanicsLabourCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'condition_modal.parts_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ mechanicsPartCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'nav_repair_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ mechanicsCost | number:'0.2' }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4 px-2">
      <div class="cost mb-3">
        <div class="cost__header">
          <h4 class="fs fs__md">{{ 'nav_frame' | translate }}</h4>
        </div>
        <div class="cost__body">
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{'condition_modal.labour_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ frameLabourCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'condition_modal.parts_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ framePartCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'nav_repair_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ frameCost | number:'0.2' }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4 px-2">
      <div class="cost mb-3">
        <div class="cost__header">
          <h4 class="fs fs__md">{{ 'nav_major_options' | translate }}</h4>
        </div>
        <div class="cost__body">
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{'condition_modal.labour_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ majorOptionsLabourCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'condition_modal.parts_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ majorOptionsPartCost | number:'0.2' }}</h2>
          </div>
          <div class="cost__type">
            <p class="fs fs__sm mb-1">{{ 'nav_repair_cost' | translate }}</p>
            <h2 class="fs fs__base font-weight-bold">SAR {{ majorOptionsCost | number:'0.2' }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
